import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';

import Configdata from './Defaultdata';
import './home.css';
import {loadwidgate} from './userdefaultdata';
import {checauthu,getanroidpin,connect} from './Androidconnet';
import {chkwbauthu} from './Webconnet';
import Pinentry from './Pinentry'; 

export default class Home extends Component {
    state = {
        name: "",
     
        url: "",
    
    };

    cities = [
        { value: 0, label: 'Others' },
        
    ];
   
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
   

    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
      
           
        this.setState({ url: appurl });
    }
    componentDidMount() {
       // debugger;
     // if(checauthu())
          if(chkwbauthu())
	loadwidgate('container',16);
	else 
        loadwidgate('container',7);
     
     
    }
    
    
 render() {

   
     return (

         <form>
	<div className="per100" id="homemain">
	 
	
        
	</div>
   	</form>
    
   
      );
}
}

